export default __webpack_public_path__ + "static/media/home-events-conference-img-14.9cc72b17.jpg";